import React, {useContext, useEffect, useState} from 'react';
import {Button, Card, Col, ListGroup, Row} from "react-bootstrap";
import {Context} from "../../index";
import {useNavigate} from "react-router-dom";
import {FaAnchorCircleCheck, FaArrowRightFromBracket} from "react-icons/fa6";
import {FaBook, FaBookOpen, FaCoins, FaHourglassHalf, FaStar, FaUser} from "react-icons/fa";
import InfoAssUnderBookS2 from "../modals/book/InfoAssUnderBookS2";
import InfoAssUnderBookS3 from "../modals/book/InfoAssUnderBookS3";

const AssignUnderBookS3 = ({ assign }) => {
    const  [infoS3Visible, setinfoS3Visible] = useState(false);

    const [showNotification, setShowNotification] = useState(false);
    // ⏱ Countdown до дедлайна появления отзыва на Амазоне
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        if (!assign?.publish_rev_date) return;

        const deadlineMs = (assign.publish_rev_date + 20160) * 60 * 1000; // unix-время в минутах → ms

        const updateTimeLeft = () => {
            const diff = deadlineMs - Date.now();

            if (diff <= 0) {
                setTimeLeft({
                    expired: true,
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
                return;
            }

            const totalSeconds = Math.floor(diff / 1000);
            const days = Math.floor(totalSeconds / (24 * 60 * 60));
            const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            setTimeLeft({
                expired: false,
                days,
                hours,
                minutes,
                seconds,
            });
        };

        updateTimeLeft();
        const timerId = setInterval(updateTimeLeft, 1000);

        return () => clearInterval(timerId);
    }, [assign?.publish_rev_date]);

    const handleCopy = () => {
        navigator.clipboard.writeText(assign.review_link);
        setShowNotification(true);

        // Скрыть уведомление через 2 секунды
        setTimeout(() => {
            setShowNotification(false);
        }, 2000);
    };


    const rep_date = new Date(assign.publish_rev_date * 60 * 1000);

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // Получаем месяц, день, год, часы и минуты
    const month = months[rep_date.getMonth()];
    const day = rep_date.getDate();
    const year = rep_date.getFullYear();
    const hours = rep_date.getHours();
    const minutes = rep_date.getMinutes();

      // Форматируем вывод (часы и минуты с ведущим нулем, если нужно)
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = hours < 10 ? `0${hours}` : hours;



    return (

        <>
            <Card
                className="mt-0 p-0 mx-auto mb-1"
                style={{
                    borderRadius: '6px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: 'pointer',
                    height: '138px', // ✅ Фиксированная высота карточки
                }}
                onClick={() => setinfoS3Visible(true)}
                onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0px 4px 12px rgba(0, 0, 0, 0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                }}
            >
                <Card.Body className="d-flex flex-column position-relative py-2 px-3">



                    {/* Условный рендеринг для статуса */}
                    {assign.assignment_status === 'REPORTED' || assign.assignment_status === 'REPORTED_RFU' || assign.assignment_status === 'REPORTED_RV' || assign.assignment_status === 'REPORTED_EXP' ? (
                        <>
                            <p
                                className=" fw-semibold mb-1 mt-0 text-muted"
                                style={{
                                    display: "block", // ✅ Заменяем `-webkit-box` на `block` для лучшего контроля
                                    maxWidth: "100%", // ✅ Заполняет всю ширину родителя
                                    overflow: "hidden",
                                    textOverflow: "ellipsis", // ✅ Обрезает в конце, а не заранее
                                    whiteSpace: "nowrap" // ✅ Чтобы работало корректно для одной строки
                                }}
                            >
                                <FaHourglassHalf className="me-1 text-success fa-spin" />
                                {/* ✅ Анимированная иконка */}
                                Reported, awaiting approval...
                            </p>

                            <Row className="gap-1">

                                {timeLeft && (
                                    <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        lineHeight: "1.2",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}>
                                        <FaHourglassHalf className="me-2" />
                                        {timeLeft.expired ? (
                                            <span className="text-danger fw-semibold">
                                            Time for the review to appear has expired.
                                        </span>
                                        ) : (
                                            <>
                                                Review go-live time left:&nbsp;
                                                <b>
                                                    {timeLeft.days}d{" "}
                                                    {String(timeLeft.hours).padStart(2, "0")}h{" "}
                                                    {String(timeLeft.minutes).padStart(2, "0")}m{" "}
                                                    {String(timeLeft.seconds).padStart(2, "0")}s
                                                </b>
                                            </>
                                        )}
                                    </p>
                                )}


                                <p className="me-2 mb-0 mt-0 small text-muted"  style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaBook className="me-1" /> {/* ✅ Улучшенная иконка */}
                                    Type:{" "}<b>
                                    {(() => {
                                        switch (assign.assTypeId) {
                                            case 1: return "Universal Assignment";
                                            case 2: return "Kindle Unlimited";
                                            case 3: return "Kindle Verified Purchase";
                                            case 4: return "Kindle Verified Purchase + Img";
                                            case 5: return "Kindle Verified Purchase Search&Buy";
                                            case 6: return "Kindle Verified Search&Buy + Img";
                                            case 7: return "Universal Assignment for Audio";
                                            case 8: return "Audible Promo Code Assignment";
                                            case 9: return "Verified Kindle Unlimited";
                                            case 10: return "Paperback BuyOut";
                                            case 11: return "Paperback Search&BuyOut";
                                            case 12: return "Paperback Verified Purchase + Img";
                                            case 13: return "Paperback Verified Purchase + Video";
                                            case 14: return "HC BuyOut";
                                            case 15: return "HC Search&BuyOut";
                                            case 16: return "HC Verified Pur. + Img";
                                            case 17: return "HC Verified + Video";
                                            case 18: return "PB Verified Purchase";
                                            case 19: return "PB Verified Purchase Search&Buy";
                                            case 20: return "HC Verified Purchase";
                                            case 21: return "HC Verified Purchase Search&Buy";
                                            case 22: return "Product BuyOut";
                                            case 23: return "Prod. Search&BuyOut";
                                            case 24: return "Prod. Verified Pur.";
                                            case 25: return "Prod. Verified + Img";
                                            case 26: return "Prod. Verified + Vid";
                                            case 27: return "Prod. VP Search&Buy";
                                            case 28: return "Make Helpful Internal";
                                            case 29: return "Write Report Internal";
                                            case 30: return "Make Helpful External";
                                            case 31: return "Write Report External";
                                            case 32: return "Set Stars Rating";
                                            default:
                                                return "Unknown Type"; // ✅ Защита от неверных значений
                                        }
                                    })()}</b>
                                </p>
                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>
                                    <FaCoins className="me-2" />
                                    Cost: <b>{assign.assignment_price_publisher || 'Unknown'}</b> Virt /
                                    <b className="text-danger">
                                        {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(assign?.assTypeId) ? (
                                            assign?.assignment_price_publisher
                                                ? ` $${assign.book_cost_compensation}`
                                                : "N/A"
                                        ) : (
                                            (() => {
                                                let priceLabel;
                                                switch (assign?.booksPriceId) {
                                                    case 1: priceLabel = " Free"; break;
                                                    case 2: priceLabel = " $0.99"; break;
                                                    case 3: priceLabel = " $1.99"; break;
                                                    case 4: priceLabel = " $2.99"; break;
                                                    case 5: priceLabel = " $3.99"; break;
                                                    case 6: priceLabel = " $4.99"; break;
                                                    case 7: priceLabel = " $5.99"; break;
                                                    case 8: priceLabel = " $6.99"; break;
                                                    case 9: priceLabel = " $7.99"; break;
                                                    case 10: priceLabel = " $8.99"; break;
                                                    case 11: priceLabel = " $9.99"; break;
                                                    default: priceLabel = " Unknown Type";
                                                }

                                                // Добавляем " Promo" при нужных условиях
                                                if (assign?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(assign?.assTypeId)) {
                                                    priceLabel += " Promo";
                                                }

                                                return priceLabel;
                                            })()
                                        )}
                                    </b>
                                </p>
                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block", // ✅ Заменяем `-webkit-box` на `block` для лучшего контроля
                                    maxWidth: "100%", // ✅ Заполняет всю ширину родителя
                                    overflow: "hidden",
                                    lineHeight: "1.2",
                                    textOverflow: "ellipsis", // ✅ Обрезает в конце, а не заранее
                                    whiteSpace: "nowrap" // ✅ Чтобы работало корректно для одной строки
                                }}>
                                    <FaUser className="me-2" />
                                    Participant: <b>{assign.reviewer_name || 'Unknown'}</b>
                                </p>
                                <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                    display: "block", // ✅ Заменяем `-webkit-box` на `block` для лучшего контроля
                                    maxWidth: "100%", // ✅ Заполняет всю ширину родителя
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    lineHeight: "1.2",// ✅ Обрезает в конце, а не заранее
                                    whiteSpace: "nowrap" // ✅ Чтобы работало корректно для одной строки
                                }}>
                                    <FaStar className="me-2" />
                                    {assign.rating
                                        ? (
                                            <>
                                                Expected Rating:{' '}
                                                <b>
                                                    {assign.rating
                                                        ? `${assign.rating}.0`
                                                        : 'Not Applicable'}
                                                </b>
                                            </>
                                        )
                                        : (
                                            <>
                                                Rating / Country:{' '}
                                                <b>
                                                    {assign.rating
                                                        ? `${assign.rating}.0`
                                                        : 'Not Applicable'}
                                                </b>
                                            </>
                                        )
                                    } /


                                    <b>
                                    {(() => {
                                        switch (assign.assignment_prefer_country) {
                                            case "https://www.amazon.com":
                                                return " US";
                                            case "https://www.amazon.ca":
                                                return " CA";
                                            case "https://www.amazon.com.au":
                                                return " AU";
                                            case "https://www.amazon.co.uk":
                                                return " UK";
                                            case "https://www.amazon.de":
                                                return " DE";
                                            case "https://www.amazon.fr":
                                                return " FR";
                                            case "https://www.amazon.it":
                                                return " IT";
                                            case "https://www.amazon.es":
                                                return " ES";
                                            case "https://www.amazon.in":
                                                return " IN";
                                            case "https://www.amazon.co.jp":
                                                return " JP";
                                            case "https://www.amazon.com.br":
                                                return " BR";
                                            case "https://www.amazon.nl":
                                                return " NL";
                                            case "https://www.amazon.com.mx":
                                                return " MX";
                                            case "https://www.amazon.sg":
                                                return " SG";
                                            case "https://www.amazon.cn":
                                                return " CH";
                                            default:
                                                return " All";
                                        }
                                    })()}</b> {assign?.rating_of_reviewer > 20 && (
                                <span className="ms-0 fw-semibold text-success">
                                        / Q-{assign.rating_of_reviewer}%
                                     </span>
                            )}
                                </p>

                            </Row>



                        </>
                    ) : ('No new assignments')}


                </Card.Body>
            </Card>
            <InfoAssUnderBookS3
                show={infoS3Visible}
                handleClose={() => setinfoS3Visible(false)}
                assignment={assign}
                // Передаем callback для обновления данных// Передаем данные книги в модалку
            />
        </>


    );
};

export default AssignUnderBookS3;
